import { GearIcon } from 'canoe/icons';

export const SETTINGS_ROUTE = {
  key: 'Settings',
  name: 'Settings',
  path: 'settings',
  icon: GearIcon,
};

// to support legacy redirect
export const PLACEMENTS_AND_EMBEDS_ROUTE = {
  key: 'PlacementsAndEmbeds',
  path: 'placementsandembeds',
};
